import isElement from '../../utils/isElement';

const HALF = 2;

const PADDING = 3;

export default function popoverPosition(player, position, $popover) {
   $popover.style.display = 'block';
   let element = player.getElement();
   const mediaWidth = element ? element.offsetWidth : 0;
   if ( isElement(position) ) {
      const parent = mediaWidth ? element : element.parentNode;
      const parentRect = parent.getBoundingClientRect();
      const rect = position.getBoundingClientRect();
      position = _half(rect.left + rect.right) - parentRect.left;
   }
   const w = $popover.offsetWidth;
   let l = Math.max(PADDING, position - _half(w));
   // native audio element doesn't have any width
   if (mediaWidth) {
      l = Math.min(l, mediaWidth - w - PADDING);
   }

   $popover.style.left = `${l}px`;
   $popover.style.display = '';
}

function _half(num) {
   return Math.floor(num / HALF);
}
